import type { FaireThemeEntity } from "../../entity_types/theme";

export const coconut_teak_tabletop_treasures: FaireThemeEntity = {
  token: "coconut-teak-tabletop-treasures",
  type: "theme",
  retailerToken: "r_bvuv8mj0x6",
  name: "Coconut + Teak Tabletop Treasures",
  description: "Natural wood serveware that pairs with your island d\u00e9cor",
  bgColor: "#F5F0D4",
  tileBgColor: "#884b29",
  productTokens: [
    "p_cexyvusbvs",
    "p_1beqghnpbf",
    "p_dq5w4b1q2o",
    "p_zs2kxjsr2c",
  ],
  exactProducts: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:50:10Z",
    importedBy: "retailer-themes-entity-migration",
  },
};
